import type { Subtask } from '~/types';

import { apiRequest } from './client';
import { buildSubtaskEndpoint, buildSubtasksEndpoint, HTTP_METHODS } from './config';

export async function createSubtask(
  projectId: string,
  taskId: string,
  subtask: Omit<Subtask, 'id' | 'taskId'>,
): Promise<Subtask> {
  if (!projectId || !taskId) {
    throw new Error('Project ID and Task ID are required to create a subtask');
  }

  const response = await apiRequest<Subtask>(buildSubtasksEndpoint(projectId, taskId), {
    method: HTTP_METHODS.POST,
    body: JSON.stringify(subtask),
  });

  return response.data;
}

export async function deleteSubtask(
  projectId: string,
  taskId: string,
  subtaskId: string,
): Promise<void> {
  await apiRequest(buildSubtaskEndpoint(projectId, taskId, subtaskId), {
    method: HTTP_METHODS.DELETE,
  });
}

export async function getSubtask(
  projectId: string,
  taskId: string,
  subtaskId: string,
): Promise<Subtask> {
  const response = await apiRequest<Subtask>(buildSubtaskEndpoint(projectId, taskId, subtaskId));

  return response.data;
}

export async function getTaskSubtasks(projectId: string, taskId: string): Promise<Subtask[]> {
  const response = await apiRequest<Subtask[]>(buildSubtasksEndpoint(projectId, taskId));
  // Defensive fallback for array endpoints that might return null/undefined
  return response.data ?? [];
}

export async function updateSubtask(
  projectId: string,
  taskId: string,
  subtaskId: string,
  updates: Partial<Subtask>,
): Promise<Subtask> {
  const response = await apiRequest<Subtask>(buildSubtaskEndpoint(projectId, taskId, subtaskId), {
    method: HTTP_METHODS.PATCH,
    body: JSON.stringify(updates),
  });

  return response.data;
}
